module.exports = __webpack_public_path__ + "static/media/Paper_Thumb_1.a0c0c00e.jpg";